<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { isLogin } from './utils/user';

export default {
  data() {
    return {
    };
  },
  methods: {
    setUserToken() {
      const { search } = window.location;
      if (!search) return;
      const query = {};
      const queries = search.split('?')[1].split('&');
      queries.forEach((item) => {
        const param = item.split('=');
        const key = param[0];
        query[key] = param[1];
      });
      const { token } = query;
      if (!token) return;
      this.$store.commit('User_setUserToken', token);
    },
  },
  created() {
    isLogin();
    this.setUserToken();
  },
};
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif , "Microsoft YaHei";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #222222;
  line-height: 1.41;
  font-size: 14px;
}
</style>
